const KEY_PREFIX = 'reech.campaign.seen.v2.';

const storage = {
    get(key) {
        try {
            return window.localStorage.getItem(key);
        } catch (e) {
            // eslint-disable-next-line no-console
            // console.warn('[campaign] localStorage.getItem failed:', e);
            return null;
        }
    },
    set(key, val) {
        try {
            window.localStorage.setItem(key, val);
        } catch (e) {
            // eslint-disable-next-line no-console
            // console.warn('[campaign] localStorage.setItem failed:', e);
        }
    }
};

function keySeen(slug) {
    return KEY_PREFIX + slug;
}

// JSON取得（軽いキャッシュ無効化）
async function fetchConfigBySlug(slug) {
    if (!slug) throw new Error('campaign slug is required');
    const url = `/campaigns/${slug}/config.json?ts=${Date.now()}`;
    let res;
    try {
        res = await fetch(url, { cache: 'no-cache' });
    } catch (e) {
        throw new Error(`campaign config network error: ${url}`);
    }
    if (!res.ok) throw new Error(`campaign config load failed: ${url} (${res.status})`);
    return res.json();
}

/** 期間・有効・画像有無の判定 */
function isDeliverable(cfg) {
    if (!cfg || cfg.enabled !== true) return false;
    if (!cfg.image) return false;
    const start = Date.parse(cfg.startAt);
    const end   = Date.parse(cfg.endAt);
    if (Number.isNaN(start) || Number.isNaN(end)) return false;
    const now = Date.now();
    return now >= start && now <= end;
}

export async function shouldOpenCampaign(slug) {
    if (storage.get(keySeen(slug))) return { open: false, cfg: null };

    const cfg = await fetchConfigBySlug(slug);
    if (!isDeliverable(cfg)) return { open: false, cfg };

    return { open: true, cfg };
}

export function markSeen(slug) {
    storage.set(keySeen(slug), '1');
}
